<template>
<div>
  <MallPreference/>
  <MallSolution/>
  <MallIot/>
  <MallApply/>
  <MallProvider/>
  <MallFooter/>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'
import MallHeader from '@/page/mall/components/mallHeader.vue'
import MallPreference from '@/page/mall/components/mallPreference.vue'
import MallSolution from '@/page/mall/components/mallSolution.vue'
import MallIot from '@/page/mall/components/mallIot.vue'
import MallApply from '@/page/mall/components/mallApply.vue'
import MallProvider from '@/page/mall/components/mallProvider.vue'
import MallFooter from '@/page/mall/components/mallFooter.vue'

export default{
  props: {
    info:{}
  },
  data(){
    return{}
  },
  components: {MallFooter, MallProvider, MallApply, MallIot, MallSolution, MallPreference, MallHeader, VImg}

}
</script>


<style scoped lang="scss">

</style>
